import TitleBlock from '@anm/components/TitleBlock';
import { flexCenter, flexRow, media } from '@anm/styles/helpers';
import styled from 'styled-components';

const mainTitleOnMobile = media.phone`
  font-size: 26px;
  line-height: 30px;
`;

export const MainTitle = styled(TitleBlock)`
  h1,
  h2,
  h3,
  h4,
  h5 {
    ${flexRow};
    font-size: 35px;
    margin-bottom: 20px;
    ${mainTitleOnMobile};
  }
`;

export const ListWrapper = styled.div`
  ${flexRow};
  ${flexCenter};
  flex-wrap: wrap;
  justify-content: flex-start;
  div {
    display: flex;
  }
`;

const wrapperOnMobile = media.phone`
  margin: 0 20px;
`;

const Wrapper = styled.div`
  margin: 0 63px;
  ${wrapperOnMobile};
`;

export default Wrapper;
